import { render, staticRenderFns } from "./PIA.vue?vue&type=template&id=0f3c8133&scoped=true&"
import script from "./PIA.vue?vue&type=script&lang=js&"
export * from "./PIA.vue?vue&type=script&lang=js&"
import style0 from "./PIA.vue?vue&type=style&index=0&id=0f3c8133&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3c8133",
  null
  
)

export default component.exports